import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import SeoHead from '../../components/common/SeoHead';
import api from '../../services/api';

const UPLOADS_BASE = process.env.REACT_APP_UPLOADS_URL || 'https://www.businessmateworkflow.in';

const ServiceList = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/services')
      .then((res) => setServices(res.data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const seo = {
    title: 'Our Services | BusinessMate Workflow',
    metaDescription: 'Explore business registration, compliance, hiring, and outsourcing services designed to help your business grow.',
    canonical: 'https://www.businessmateworkflow.in/services',
    robots: 'index,follow'
  };

  return (
    <main>
      <SeoHead seo={seo} />
      <Navbar />

      <section style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', padding: '40px 0', color: '#fff' }}>
        <div className="container text-center">
          <h1 style={{ fontSize: 40, fontWeight: 700 }}>Our Services</h1>
          <p style={{ fontSize: 18, opacity: 0.85, maxWidth: 640, margin: '16px auto 0' }}>
            Everything your business needs, from registration to growth, in one place.
          </p>
        </div>
      </section>

      <section style={{ padding: '60px 0' }}>
        <div className="container">
          {loading ? (
            <p className="text-center">Loading services...</p>
          ) : services.length === 0 ? (
            <p className="text-center">No services published yet.</p>
          ) : (
            <div className="row g-4">
              {services.map((service) => (
                <div className="col-lg-4 col-md-6" key={service.id}>
                  <Link to={`/${service.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div style={{
                      border: '1px solid #e5e7eb',
                      borderRadius: 12,
                      overflow: 'hidden',
                      height: '100%',
                      transition: 'box-shadow 0.2s',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                    }}>
                      {service.banner_image && (
                        <img
                          src={`${UPLOADS_BASE}/${service.banner_image}`}
                          alt={service.banner_image_alt || service.service_name}
                          style={{ width: '100%', height: 180, objectFit: 'cover' }}
                        />
                      )}
                      <div style={{ padding: 20 }}>
                        <h3 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>{service.service_name}</h3>
                        <p style={{ color: '#64748b', fontSize: 15 }}>{service.short_description}</p>
                        <span style={{ color: '#06b590', fontWeight: 600, fontSize: 14 }}>Learn more &rarr;</span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default ServiceList;
